/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment,
  MenuItem,
  Autocomplete
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateUserAdd } from '../../assets/validation';
import globalAction from '../../store/actions/GlobalAction';
import UserAction from '../../store/actions/UserAction';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import DeptAction from '../../store/actions/DepartmentAction';
import RolePermAction from '../../store/actions/RolePermAction';

function UserEdit({ itemId, openmodal, onCloseModal }) {
  /* Modal Style */
  const dispatch = useDispatch();

  // Replace 'data' with your reducer name
  const { userItemData, isLoading } = useSelector((state) => state.user);
  const { statusData } = useSelector((state) => state.global);
  const { activeDeptData } = useSelector((state) => state.department);
  const { activeRoleData } = useSelector((state) => state.rolePermission);

  useEffect(() => {
    dispatch(DeptAction.getActiveItem());
    dispatch(RolePermAction.getActiveItem());
    dispatch(UserAction.getItem(itemId));
    dispatch(globalAction.getClientStatus());
  }, [dispatch, itemId]);

  // useEffect(() => {
  //   if (listData) {
  //     if (listData.data) {
  //       setData(listData.data);
  //     } else {
  //       setData([]);
  //     }
  //     setRowCountState((prevRowCountState) =>
  //       listData.total !== undefined ? listData.total : prevRowCountState
  //     );
  //   }
  // }, [listData]);

  const getDirtyValues = (values, initialObject) => {
    const data = { ...values };
    const keyValues = Object.keys(data);

    const dirtyValues = keyValues.filter((keyValue) => data[keyValue] !== initialObject[keyValue]);

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete data[key];
    });
    return data;
  };

  const initialValues = {
    name: userItemData?.name || '',
    status: userItemData?.status || '',
    status_name: userItemData?.status_name || '',
    email: userItemData?.email || '',
    department: userItemData?.department || null,
    role: userItemData?.role || null
  };

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        {isLoading ? <ContentLoader /> : ''}
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={ValidateUserAdd}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            const updateValues = getDirtyValues(values, initialValues);
            const newValues = { ...updateValues };
            if (typeof updateValues.email === 'string') {
              newValues.email = updateValues.email.trim().toLowerCase();
            }
            if (updateValues.department?._id) {
              newValues.department = updateValues.department._id;
            }
            if (updateValues.role?._id) {
              newValues.role = updateValues.role._id;
            }
            dispatch(UserAction.update(itemId, newValues, setErrors, setSubmitting, onCloseModal));
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="Edit User"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="Name"
                    name="name"
                    margin="normal"
                    placeholder="Enter User Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                      handleBlur(e);
                    }}
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name && errors.name}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-measure" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="email"
                    type="email"
                    fullWidth
                    label="Email ID"
                    name="email"
                    margin="normal"
                    placeholder="Enter Email ID"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const val = (e.target.value || '').replace(/\s+/gi, '');
                      setFieldValue(e.target.name, val.trim());
                      handleBlur(e);
                    }}
                    error={errors.email && touched.email}
                    helperText={errors.email && touched.email && errors.email}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-email" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <Field
                    name="department"
                    component={Autocomplete}
                    className="CurrencyField"
                    options={activeDeptData ?? []}
                    isOptionEqualToValue={(option, value) => option.name === value.name}
                    filterSelectedOptions
                    value={values.department}
                    // disableClearable
                    onChange={(e, newvalue) => {
                      setFieldValue('department', newvalue);
                      // if (newvalue && newvalue._id) {
                      //   setFieldValue('department', newvalue._id);
                      // }
                    }}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option._id}>
                          {option.name}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="department"
                        error={touched.department && !!errors.department}
                        helperText={touched.department && errors.department}
                        label="Department Name"
                        placeholder="Search Department"
                        variant="outlined"
                        margin="normal"
                        required={false}
                        InputLabelProps={{ required: true }}
                        // SelectProps={{
                        //   IconComponent: ExpandMore
                        // }}
                      />
                    )}
                  />
                  <Field
                    name="role"
                    component={Autocomplete}
                    className="CurrencyField"
                    options={activeRoleData ?? []}
                    isOptionEqualToValue={(option, value) => option.name === value.name}
                    filterSelectedOptions
                    value={values.role}
                    // disableClearable
                    onChange={(e, newvalue) => {
                      setFieldValue('role', newvalue);
                      // if (newvalue && newvalue._id) {
                      //   setFieldValue('role', newvalue._id);
                      // }
                    }}
                    // loading={isLoading}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option._id}>
                          {option.name}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="role"
                        error={touched.role && !!errors.role}
                        helperText={touched.role && errors.role}
                        label="Role Name"
                        placeholder="Search Role"
                        variant="outlined"
                        margin="normal"
                      />
                    )}
                  />
                  {values.status === 14 ? (
                    <TextField
                      id="status_name"
                      fullWidth
                      label="Status"
                      name="status_name"
                      disabled
                      margin="normal"
                      value={values.status_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  ) : (
                    <TextField
                      id="status"
                      fullWidth
                      label="Status"
                      name="status"
                      margin="normal"
                      select
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.status && touched.status}
                      helperText={errors.status && touched.status && errors.status}
                      required={false}
                      InputLabelProps={{ required: true }}
                    >
                      {statusData &&
                        statusData.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.status}
                          </MenuItem>
                        ))}
                    </TextField>
                  )}
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
UserEdit.propTypes = {
  itemId: PropTypes.string.isRequired,
  openmodal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default UserEdit;
